export default function LayoutCopyright() {
  return (
    <footer className="padding-s">
      <div>
        &copy; 2024{" "}
        <a href="https://edge-solutions.online/" target="_blank">
          Edge Solutions Online
        </a>
        . Thank you for innovating with us.
      </div>
    </footer>
  );
}
